import Details from "@/bloks/Details";
import type { DetailsBlok } from "@/bloks/Details/Details";

import styles from "./productDesigner.module.scss";

interface UIProps {
  details: DetailsBlok;
}

const UI = ({ details }: UIProps) => {
  return (
    <div className={styles.container}>
      <Details blok={details} />
    </div>
  );
};

export default UI;
